export const loadScript = async (src: string, async = true, type = 'text/javascript'): Promise<{ sdk: any}> => {
  return await new Promise((resolve, reject) => {
    try {
      const el = document.createElement('script')
      // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
      const container = document.head || document.body

      el.type = type
      el.async = async
      el.src = src

      el.addEventListener('load', () => {
        resolve({ sdk: window['sdk-react-dsx-everywhere'] })
      })

      el.addEventListener('error', () => {
        reject(new Error(`Failed to load the script ${src}`))
      })

      container.appendChild(el)
    } catch (err) {
      reject(err)
    }
  })
}

export const loadStyle = (href: string): Promise<void> => {
  return new Promise((resolve, reject) => {
    try {
      // Avoid duplicate loads
      if (document.querySelector(`link[href="${href}"]`)) {
        resolve();
        return;
      }

      const link = document.createElement('link');
      const container = document.head || document.body;

      link.rel = 'stylesheet';
      link.href = href;

      link.addEventListener('load', () => resolve());
      link.addEventListener('error', () =>
        reject(new Error(`Failed to load stylesheet ${href}`))
      );

      container.appendChild(link);
    } catch (err) {
      reject(err);
    }
  });
};
